import { actionCreatorFactory } from 'typescript-fsa'
import { User } from '../../types/'

const actionCreator = actionCreatorFactory()

export const login = actionCreator<User>('login')
export const logout = actionCreator('logout')
export const loginFailed = actionCreator('loginFailed')
